var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g878"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g655"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.14,43.8c10.26,2.05,16.91,12.12,14.86,22.42-2.07,10.33-12.09,17.04-22.34,14.99-10.23-2.05-16.92-12.1-14.85-22.43,2.06-10.29,12.1-17.03,22.33-14.98ZM88.68,81.09c10.19,2.04,20.14-4.65,22.2-14.9,2.04-10.25-4.57-20.24-14.76-22.28-10.17-2.03-20.14,4.65-22.19,14.89-2.05,10.25,4.58,20.26,14.75,22.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path657"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.06,72.1c-2.69,1.32-4.31,1.8-5.38,1.86-1.72-2.15-3.4-4.75-4.36-7.16.69-1.86,1.48-3.63,2.4-5.3,2.05.95,4.1,1.91,6.17,2.84.39,2.6.78,5.17,1.18,7.76h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path658"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.11,80.23c-1.71-2.14-1.2-1.96-2.14-4.37.97-.85,5.5-3.34,6.73-4.79,1.99.64,3.66.67,5.71,1.61-.57,3.24-2.95,5.14-2.95,5.51h0c-1.89.95-6.28,1.97-7.35,2.03h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path659"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.87,59.3c-.29-2.21.14-5.73.37-8.07.96-.8,5.82-1.54,7.92-1.72,2.22,2,3.63,4.91,4.58,7.05-1.69,2.88-3.64,4.73-4.85,5.85-2.67-1.02-5.35-2.06-8.02-3.11h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path660"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.35,59.2c.58-1.44.39-2.56.31-3.74.09-.03.15.02.25-.11,2.02,4.33,1.51,9.92.88,11.69-.19-.06-.32-.12-.5-.18.25-2.78-.23-5.85-.94-7.66h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path661"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.38,52.39c2.28-3.75,6.86-6.99,9.16-7.45.29.09.55.11.78.19-1.38,1.48-1.44,3-1.69,3.66-2.36.36-5.14,3.86-6.54,4.89-.62-.26-.88-.5-1.71-1.3h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path662"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.51,44.14c.29.09,2.36.82,2.61.92,1.82.78,4.55,2.63,5.1,3.43-1.53-1.08-3.13-1.9-3.79-2.31-.44-.12-.63-.24-1.6-.07.21-1.06-3.54-2.01-4.1-2.31.46,0,.62.12,1.79.34h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path663",
    className: "cls-1",
    d: "M99.75,71.09c.59-2.25.21-5.6-.85-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.96,62.42c1.11,3.17,1.44,6.5.86,8.68l-.12-.03c.56-2.15.23-5.45-.87-8.59l.13-.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path664",
    className: "cls-1",
    d: "M85.05,72.17c.79.87,4.58,2.64,8.01,3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.1,72.13c.8.87,4.59,2.62,7.97,3.67l-.03.14c-3.42-1.05-7.23-2.83-8.05-3.7l.1-.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path665",
    className: "cls-1",
    d: "M90.89,59.27c-3.11,2.04-4.72,3.16-7.02,5.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.87,59.22l.07.12c-2.99,1.95-4.68,3.1-7.05,5.11l-.07-.11c2.35-2.01,4.04-3.15,7.05-5.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path666",
    className: "cls-1",
    d: "M91.24,51.25c-2.43-1.69-4.16-2.28-6.57-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.35,48.92c1.72.34,3.14,1.03,4.93,2.29l-.09.12c-2.3-1.62-4.01-2.29-6.54-2.49v-.14c.61.05,1.18.12,1.7.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path667",
    className: "cls-1",
    d: "M99.21,49.63c.62-1.68.57-2.47.66-3.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.94,46.16c0,.17-.02.33-.04.49-.06.81-.09,1.58-.62,3l-.15-.04c.54-1.4.59-2.16.63-2.98,0-.14.02-.31.03-.48h.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path668",
    className: "cls-1",
    d: "M103.7,56.55c4.5.86,4.83,1.67,5.66,2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.09,56.55c3.79.76,4.44,1.53,5.12,2.32.07.08.14.16.22.25l-.12.1c-.07-.08-.14-.16-.21-.24-.71-.85-1.33-1.56-5.42-2.34l.03-.15c.13.02.25.05.38.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path669",
    className: "cls-1",
    d: "M105.37,72.68c2.93-1.99,3.93-4.06,4.92-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.23,66.7l.13.07c-.07.11-.14.23-.2.36-.93,1.75-2.01,3.72-4.73,5.6l-.07-.12c2.68-1.84,3.75-3.81,4.68-5.55.07-.14.14-.26.2-.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path670",
    className: "cls-1",
    d: "M102.64,78.51c-.17-.16-.15-.14-.21-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.52,78.23v.03q.04.07.14.17l.03.06-.1.08-.03-.04c-.13-.09-.13-.13-.16-.21v-.02s.12-.06.12-.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path671",
    className: "cls-1",
    d: "M82.97,78.93c-1.86-1.85-2.91-4.04-3.28-4.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.76,73.94c.26.65,1.31,2.98,3.25,4.93l-.1.12c-1.97-1.96-3.02-4.31-3.3-4.97l.15-.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path672",
    className: "cls-1",
    d: "M78.1,53.75c-.33,1.66-1.05,6.83-.21,7.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.16,53.76c-.19.96-.43,2.65-.54,4.15-.13,1.94-.02,3.17.32,3.57l-.11.1c-.91-1.03-.07-6.53.19-7.85l.14.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path673",
    className: "cls-1",
    d: "M73.53,64.82c.37.97.82,1.45,1.8,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.58,64.79c.36.96.84,1.45,1.79,1.89l-.06.13c-1.01-.46-1.47-.95-1.87-1.98l.14-.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path674",
    className: "cls-1",
    d: "M88.01,80.9c4.13.33,5.96-.2,7.05-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.03,80.18l.06.14c-1.15.46-3.01.97-7.08.66v-.14c4.05.3,5.89-.18,7.02-.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path607"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.06,72.1c-2.69,1.32-4.31,1.8-5.38,1.86-1.72-2.15-3.4-4.75-4.36-7.16.69-1.86,1.48-3.63,2.4-5.3,2.05.95,4.1,1.91,6.17,2.84.39,2.6.78,5.17,1.18,7.76h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.11,80.23c-1.71-2.14-1.2-1.96-2.14-4.37.97-.85,5.5-3.34,6.73-4.79,1.99.64,3.66.67,5.71,1.61-.57,3.24-2.95,5.14-2.95,5.51h0c-1.89.95-6.28,1.97-7.35,2.03h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path609"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.87,59.3c-.29-2.21.14-5.73.37-8.07.96-.8,5.82-1.54,7.92-1.72,2.22,2,3.63,4.91,4.58,7.05-1.69,2.88-3.64,4.73-4.85,5.85-2.67-1.02-5.35-2.06-8.02-3.11h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path610"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.35,59.2c.58-1.44.39-2.56.31-3.74.09-.03.15.02.25-.11,2.02,4.33,1.51,9.92.88,11.69-.19-.06-.32-.12-.5-.18.25-2.78-.23-5.85-.94-7.66h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path611"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.38,52.39c2.28-3.75,6.86-6.99,9.16-7.45.29.09.55.11.78.19-1.38,1.48-1.44,3-1.69,3.66-2.36.36-5.14,3.86-6.54,4.89-.62-.26-.88-.5-1.71-1.3h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.51,44.14c.29.09,2.36.82,2.61.92,1.82.78,4.55,2.63,5.1,3.43-1.53-1.08-3.13-1.9-3.79-2.31-.44-.12-.63-.24-1.6-.07.21-1.06-3.54-2.01-4.1-2.31.46,0,.62.12,1.79.34h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.96,62.42c1.11,3.17,1.44,6.5.86,8.68l-.12-.03c.56-2.15.23-5.45-.87-8.59l.13-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.1,72.13c.8.87,4.59,2.62,7.97,3.67l-.03.14c-3.42-1.05-7.23-2.83-8.05-3.7l.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.87,59.22l.07.12c-2.99,1.95-4.68,3.1-7.05,5.11l-.07-.11c2.35-2.01,4.04-3.15,7.05-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.35,48.92c1.72.34,3.14,1.03,4.93,2.29l-.09.12c-2.3-1.62-4.01-2.29-6.54-2.49v-.14c.61.05,1.18.12,1.7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.94,46.16c0,.17-.02.33-.04.49-.06.81-.09,1.58-.62,3l-.15-.04c.54-1.4.59-2.16.63-2.98,0-.14.02-.31.03-.48h.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.09,56.55c3.79.76,4.44,1.53,5.12,2.32.07.08.14.16.22.25l-.12.1c-.07-.08-.14-.16-.21-.24-.71-.85-1.33-1.56-5.42-2.34l.03-.15c.13.02.25.05.38.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.23,66.7l.13.07c-.07.11-.14.23-.2.36-.93,1.75-2.01,3.72-4.73,5.6l-.07-.12c2.68-1.84,3.75-3.81,4.68-5.55.07-.14.14-.26.2-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.52,78.23v.03q.04.07.14.17l.03.06-.1.08-.03-.04c-.13-.09-.13-.13-.16-.21v-.02s.12-.06.12-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.76,73.94c.26.65,1.31,2.98,3.25,4.93l-.1.12c-1.97-1.96-3.02-4.31-3.3-4.97l.15-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.16,53.76c-.19.96-.43,2.65-.54,4.15-.13,1.94-.02,3.17.32,3.57l-.11.1c-.91-1.03-.07-6.53.19-7.85l.14.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.58,64.79c.36.96.84,1.45,1.79,1.89l-.06.13c-1.01-.46-1.47-.95-1.87-1.98l.14-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.03,80.18l.06.14c-1.15.46-3.01.97-7.08.66v-.14c4.05.3,5.89-.18,7.02-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path646"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.68,57.63c-.95-.09-1.55,1.46-1.87,1.98-.92,1.47-1.48,1.72-2.62,1.16-1.17-.19-3.42-1.06-5.11-1.74.05-.75.8-3.35.76-4.11-.06-.62-.77-.03-.37-1.91.08.55-.4,4.6-.34,6.03.78.66,1.71.73,3.15,1.42,1.41.66,3.09,1.2,4.54,1.84.54-.25.89-.99,1.38-1.21l1.21-1.72s.1-1.64-.72-1.73h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path717"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.8,64.43c-1.18-.66-2.28-1-3.61-1.61-.64-.32-1.82-.93-2.41-1.18.3.37.97.83,1.18.91.27.12,1.71.81,1.95,1,.8.31,1.31.51,1.86.68.05,0,.78.16,1.02.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path718"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.97,72.14c-.08-1.55-.46-2.84-.69-4.53-.13-.81-.25-2.32-.37-3.08-.24.51-.25,1.44-.22,1.7.07.33.29,2.14.25,2.51.22.98.38,1.62.54,2.27.04.03.4.86.5,1.12h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path719"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.97,71.91c-.96.93-3.47,2.31-4.65,3.11-.42.24-.76.32-1.2.81.4-.14,2.12-1.1,2.26-1.31.18-.2,1.73-1.02,1.99-1.19.55-.68.64-.18.99-.66.02-.06,1.21-1.25,1.33-1.46l-.71.7h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path720"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.35,72.76c-.81-.37-1.2-.53-2.5-.79-.59-.19-2.59-.64-3.13-.84.27.28.93.56,1.12.61.25.06,1.58.5,1.83.61.75.19,1.24.29,1.74.36.04,0,.73.03.94.06h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path874"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.05,51.69c1.99-3.17,6.04-5.93,8.06-6.33.27.11.5.1.7.21-1.24,1.25-1.27,2.56-1.47,3.13-2.08.29-4.53,3.28-5.78,4.13-.54-.23-.78-.42-1.51-1.14h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path876"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.35,59.2c.58-1.44.39-2.56.31-3.74.09-.03.15.02.25-.11,2.02,4.33,1.51,9.92.88,11.69-.19-.06-.32-.12-.5-.18.25-2.78-.23-5.85-.94-7.66h0Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.58,59.77c-.29,0-.54-.05-.73-.11l-.14-.05-1.47-1.29c-2.08-1.41-1.82-2.56-1.69-2.88.48-1.66,2.39-3.55,2.47-3.63l1.05,1.07c-.47.46-1.76,1.9-2.1,3.03.02.09.17.54,1.18,1.23l1.29,1.13c.23.03.77,0,1.19-.72l1.69-2.18,1.18.92-1.63,2.1c-.63,1.08-1.57,1.39-2.3,1.39ZM44.97,55.92v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.88,65.57l-.32-.14c-1.52-.65-3.21-3.17-3.4-3.46l-.17-.26.06-.3c.38-1.83,3.04-3.93,3.34-4.16l.92,1.19c-.89.68-2.3,2.03-2.7,3,.58.82,1.5,1.95,2.23,2.44.51-.33,1.56-1.11,2.75-2.5l1.14.98c-1.88,2.2-3.46,3.03-3.53,3.06l-.31.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.21,59.95l-1.55-2.04c-.48-.87-.87-1.05-1.02-1.09-.16-.04-.26.02-.28.03l-.9-1.2c.06-.05.64-.48,1.46-.31.76.16,1.44.76,2.02,1.79l1.46,1.9-1.19.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.2,64.91c-2.95-2.79-3.79-2.91-3.83-2.92.05,0,.25-.02.42-.21l-1.13-.99c.09-.1.3-.28.66-.29.58-.03,1.7.29,4.9,3.33l-1.03,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.12,80.88c-.29,0-.47-.04-.5-.05l-.18-.04-1.46-1.28c-.83-.78-1.21-1.52-1.15-2.21.05-.56.36-.88.53-1.02l1.62-1.66,1.07,1.05-1.78,1.8c.07-.02.03.28.72.93l1.13.99c.34,0,1.23-.12,2.14-1.33l1.2.9c-1.25,1.68-2.62,1.93-3.34,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.73,85.78s-.03,0-.04,0c-.89-.02-1.72-.78-2.01-1.08-1.37-.83-1.48-1.64-1.48-1.87l.02-.16c.3-1.43,2.37-2.81,2.78-3.07l.8,1.27c-.71.45-1.78,1.34-2.06,1.94.08.12.29.36.79.64l.17.14c.37.4.88.7,1.04.68l.08-.07,1.79-1.27.87,1.22-1.74,1.24c-.28.25-.62.38-1,.38ZM70.68,82.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.8,90.93c-.27,0-.47-.06-.53-.08l-.18-.06-1.92-2.11-.04-.2c-.27-1.26,1.71-2.78,2.91-3.58l.82,1.25c-.98.65-1.94,1.5-2.2,1.93l1.22,1.34c.29-.05.82-.46,1.22-1.81l1.44.42c-.4,1.35-1,2.24-1.8,2.65-.36.18-.69.24-.95.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.98,94.71c-1.12-.41-1.71-2.31-1.86-2.89-.09-.37-.32-1.42,3.27-2.7l.5,1.41c-.94.34-1.94.83-2.26,1.12.24.76.64,1.54.87,1.65l-.52,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.02,86.82l-1.09-1.03c.81-.86-.22-2.18-.53-2.54-1.36-.74-.94-2.98-.82-3.5.02-1.13-1.48-1.35-1.66-1.37l.17-1.49c1.09.12,3.11.91,2.98,3.01l-.02.13c-.2.83-.16,1.8.09,1.9l.15.06.11.12c.89.92,2.16,3.08.63,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.88,83.65l-.4-1.45c.46-.13,1-.37,1.12-.5,0,0-.03.04-.05.12l1.47.32c-.19.86-1.42,1.32-2.13,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.92,90.72c-1.47-2.29-2.27-2.48-2.41-2.49l-1.01-1.13c.21-.21.62-.43,1.16-.36,1.06.11,2.21,1.15,3.52,3.17l-1.26.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.76,93.92c-1.32-2.13-2.5-1.7-2.55-1.68l-.6-1.37c.1-.04,2.38-1.03,4.42,2.26l-1.27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.33,60.83l-1.85-2.81s-.04-.04-.06-.06c-.03.06-.05.12-.07.17l-1.45-.4c.05-.19.35-1.13,1.18-1.33.37-.08.94-.04,1.55.65l.07.09,1.88,2.86-1.25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.74,66.15c-1.82-2.04-3.18-2.33-3.19-2.33l.25-1.48c.19.03,1.89.37,4.06,2.82l-1.12,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.84,58.99l-1.5-.1c-.04-.24-.69-1-1.36-1.54l-.08-.08c-.87-.96-1.26-.92-1.27-.92,0,0,.05,0,.13-.09l-1.04-1.08c.09-.08.42-.37.98-.33.7.02,1.46.48,2.28,1.37.62.51,1.93,1.72,1.86,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.97,64.69c-.88-.49-1.69-1.79-1.85-2.04-.25-.5-.57-.62-1.01-.42l-.66-1.35c.09-.04.88-.42,1.74-.13.37.13.9.44,1.25,1.18.27.43.87,1.23,1.26,1.45l-.73,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.54,80.32c-1.07-2.17-1.83-2.24-1.84-2.24h0s.03,0,.1-.02l-.46-1.43c.42-.14,1.91-.32,3.55,3.03l-1.35.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.13,85.22c-.07-.2-.56-1.09-1-1.83-.12-.1-.18-.08-.22-.07-.1.03-.2.11-.22.13l-1.07-1.05c.06-.06.59-.59,1.35-.59h0c.33,0,.82.1,1.3.59l.11.14c.32.54,1.08,1.84,1.2,2.27l-1.44.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.43,90.25c-.2-1.19-.52-1.54-.63-1.58-.09-.02-.33.11-.41.19l-1.05-1.07c.09-.09.92-.87,1.92-.55.84.27,1.38,1.17,1.65,2.75l-1.48.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.25,94.01h-1.5v-1.6c-.11,0-.28,0-.4.03l-.36-1.46c.18-.04,1.1-.24,1.73.23.33.24.52.61.54,1.05v1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.17,82.25l-1.4-.54c.42-1.08.28-1.38.28-1.38,0,.02-.14.04-.17.04l-.42-1.44c.11-.03,1.08-.29,1.7.4.8.87.2,2.41,0,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.61,86.99c-.14-1.56-.53-1.82-.55-1.83l-.75-1.32c.32-.18.89-.3,1.44,0,.76.4,1.21,1.39,1.35,3.03l-1.49.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.09,91.81c-1.04-1.9-1.57-1.99-1.58-1.99.07,0,.11-.06.12-.08l-1.3-.75c.18-.31.59-.67,1.18-.67h.02c.93.01,1.85.89,2.87,2.77l-1.32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.26,70.94l-.72-1.32c.71-.39,1.15-.91,1.33-1.6.38-1.43-.44-3.28-.84-3.99-3.68-3.29-10.41-15.83-10.7-16.37-3.21-4.81-5-4.8-5.01-4.8-3.26,1.13-5.71.54-5.81.52l.36-1.46s2.15.5,4.97-.48c.44-.14,2.78-.54,6.78,5.45.11.19,7.04,13.11,10.48,16.09l.15.17c.07.11,1.71,2.83,1.07,5.25-.29,1.09-.98,1.95-2.06,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.9,39.54l-1.45-.4c.02-.07,1.81-6.74-.72-14.1-.06-.21-4.32-16.13-6.33-19.23l1.26-.81c2.14,3.3,6.33,18.95,6.5,19.61,2.67,7.76.81,14.65.73,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.82,49.73l-1.43-.44c1.87-6.06-.6-11.75-.62-11.8-1.86-5.5-1.41-31.02-1.39-32.1l1.5.03c0,.26-.47,26.35,1.28,31.53.09.19,2.69,6.18.66,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.08,95.54l-4.04-2.47.9-1.39-.43-.39-1.59,1.19-3.59-2.49-.09-1.22.77-1.02-.63-.53-1.22.67-2.65-3.26.46-1.19-.09-.93-1.3-2.74.36-1.31c.02-.08,1.37-5-8.22-13.09l-.82.75c-.17.33-.57.91-1.19,1.02-.23.04-.69.04-1.11-.4l-3.18-2.78.3-.53s.41-.75.64-2.19l-.57-.62-.44.47c-.15.14-.66.54-1.26.49-.35-.03-.66-.19-.9-.47l-2.31-2.89v-.24c-.02-.13-.07-1.32.48-2.34l.07-.11c.08-.11.35-.54.03-.89l-.11-.13-.05-.16c-.06-.21-1.48-5.22,2.54-9.38.01-.01,2.06-2.21,3.94-5.4l.13-.16c.11-.11,2.78-2.62,5.43-2.32,1.17.13,2.14.77,2.88,1.89.06.09,5.87,8.88,13.48,10.14l.21.07c1.44.72,3.92,2.99,3.21,6.52,2.15,4.21,15.91,31.67,11.27,36.58-.42.71-2.79,3.95-9.99,2.03l-1.35,1.23ZM68.13,92.59l1.76,1.08,1.13-1.03.4.12c6.93,1.98,8.64-1.13,8.71-1.27l.15-.21c3.15-3.01-5.45-23.15-11.61-35.14l-.13-.25.07-.27c.76-3.14-1.75-4.75-2.28-5.05-8.2-1.43-14.12-10.39-14.36-10.77-.49-.74-1.07-1.14-1.79-1.22-1.56-.18-3.46,1.21-4.16,1.84-1.95,3.29-4,5.49-4.09,5.58-3.1,3.21-2.41,7-2.22,7.78.74.98.33,2.08-.05,2.6-.23.45-.28.99-.29,1.28l1.9,2.37s.04-.02.05-.04l1.47-1.61,2.15,2.35-.04.35c-.15,1.16-.42,2-.62,2.51l2.22,1.94c.04-.06.08-.14.11-.19l.06-.14,2-1.82.5.41c11.05,9.1,9.27,14.87,9.19,15.11l-.2.73,1.19,2.59.14,1.42-.28.71,1.31,1.61,1.02-.56,2.5,2.11-1.26,1.67,2.08,1.44,1.72-1.28,2.29,2.08-.76,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.71,94.42l-.07-1.15s-.21-2.99-2.03-6.13c-.02-.04-3.16-5.19-8.76-10.66-.28-.25-7.62-6.77-11.56-13.16-2.43-3.5-9.8-12.46-14.44-11.43l-.12.02c-.07,0-1.75.14-2.14,1.6l-1.24,4.69-.33-6.77.11-.19c.08-.13,1.92-3.17,6.85-1.79.13.01,5.25.93,12.83,11.09.08.1,8.94,11.32,12.32,14.17.5.46,11.53,10.85,11.11,17.6l-.02.24-.15.19c-.06.08-.65.78-1.35,1.14l-1.02.54ZM79.17,89.07c.05.14.1.27.14.4-.04-.13-.09-.27-.14-.4ZM75.2,82.51c.6.78,1.1,1.47,1.5,2.04-.48-.7-.98-1.38-1.5-2.04ZM57.85,62.98c2.29,3.55,5.64,7.17,8.05,9.57-2.84-3.14-6.25-7.33-8.05-9.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.58,59.77c-.29,0-.54-.05-.73-.11l-.14-.05-1.47-1.29c-2.08-1.41-1.82-2.56-1.69-2.88.48-1.66,2.39-3.55,2.47-3.63l1.05,1.07c-.47.46-1.76,1.9-2.1,3.03.02.09.17.54,1.18,1.23l1.29,1.13c.23.03.77,0,1.19-.72l1.69-2.18,1.18.92-1.63,2.1c-.63,1.08-1.57,1.39-2.3,1.39ZM44.97,55.92v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.88,65.57l-.32-.14c-1.52-.65-3.21-3.17-3.4-3.46l-.17-.26.06-.3c.38-1.83,3.04-3.93,3.34-4.16l.92,1.19c-.89.68-2.3,2.03-2.7,3,.58.82,1.5,1.95,2.23,2.44.51-.33,1.56-1.11,2.75-2.5l1.14.98c-1.88,2.2-3.46,3.03-3.53,3.06l-.31.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.21,59.95l-1.55-2.04c-.48-.87-.87-1.05-1.02-1.09-.16-.04-.26.02-.28.03l-.9-1.2c.06-.05.64-.48,1.46-.31.76.16,1.44.76,2.02,1.79l1.46,1.9-1.19.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.2,64.91c-2.95-2.79-3.79-2.91-3.83-2.92.05,0,.25-.02.42-.21l-1.13-.99c.09-.1.3-.28.66-.29.58-.03,1.7.29,4.9,3.33l-1.03,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.12,80.88c-.29,0-.47-.04-.5-.05l-.18-.04-1.46-1.28c-.83-.78-1.21-1.52-1.15-2.21.05-.56.36-.88.53-1.02l1.62-1.66,1.07,1.05-1.78,1.8c.07-.02.03.28.72.93l1.13.99c.34,0,1.23-.12,2.14-1.33l1.2.9c-1.25,1.68-2.62,1.93-3.34,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.73,85.78s-.03,0-.04,0c-.89-.02-1.72-.78-2.01-1.08-1.37-.83-1.48-1.64-1.48-1.87l.02-.16c.3-1.43,2.37-2.81,2.78-3.07l.8,1.27c-.71.45-1.78,1.34-2.06,1.94.08.12.29.36.79.64l.17.14c.37.4.88.7,1.04.68l.08-.07,1.79-1.27.87,1.22-1.74,1.24c-.28.25-.62.38-1,.38ZM70.68,82.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.8,90.93c-.27,0-.47-.06-.53-.08l-.18-.06-1.92-2.11-.04-.2c-.27-1.26,1.71-2.78,2.91-3.58l.82,1.25c-.98.65-1.94,1.5-2.2,1.93l1.22,1.34c.29-.05.82-.46,1.22-1.81l1.44.42c-.4,1.35-1,2.24-1.8,2.65-.36.18-.69.24-.95.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.98,94.71c-1.12-.41-1.71-2.31-1.86-2.89-.09-.37-.32-1.42,3.27-2.7l.5,1.41c-.94.34-1.94.83-2.26,1.12.24.76.64,1.54.87,1.65l-.52,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.02,86.82l-1.09-1.03c.81-.86-.22-2.18-.53-2.54-1.36-.74-.94-2.98-.82-3.5.02-1.13-1.48-1.35-1.66-1.37l.17-1.49c1.09.12,3.11.91,2.98,3.01l-.02.13c-.2.83-.16,1.8.09,1.9l.15.06.11.12c.89.92,2.16,3.08.63,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.88,83.65l-.4-1.45c.46-.13,1-.37,1.12-.5,0,0-.03.04-.05.12l1.47.32c-.19.86-1.42,1.32-2.13,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.92,90.72c-1.47-2.29-2.27-2.48-2.41-2.49l-1.01-1.13c.21-.21.62-.43,1.16-.36,1.06.11,2.21,1.15,3.52,3.17l-1.26.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.76,93.92c-1.32-2.13-2.5-1.7-2.55-1.68l-.6-1.37c.1-.04,2.38-1.03,4.42,2.26l-1.27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.33,60.83l-1.85-2.81s-.04-.04-.06-.06c-.03.06-.05.12-.07.17l-1.45-.4c.05-.19.35-1.13,1.18-1.33.37-.08.94-.04,1.55.65l.07.09,1.88,2.86-1.25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.74,66.15c-1.82-2.04-3.18-2.33-3.19-2.33l.25-1.48c.19.03,1.89.37,4.06,2.82l-1.12,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.84,58.99l-1.5-.1c-.04-.24-.69-1-1.36-1.54l-.08-.08c-.87-.96-1.26-.92-1.27-.92,0,0,.05,0,.13-.09l-1.04-1.08c.09-.08.42-.37.98-.33.7.02,1.46.48,2.28,1.37.62.51,1.93,1.72,1.86,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.97,64.69c-.88-.49-1.69-1.79-1.85-2.04-.25-.5-.57-.62-1.01-.42l-.66-1.35c.09-.04.88-.42,1.74-.13.37.13.9.44,1.25,1.18.27.43.87,1.23,1.26,1.45l-.73,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.54,80.32c-1.07-2.17-1.83-2.24-1.84-2.24h0s.03,0,.1-.02l-.46-1.43c.42-.14,1.91-.32,3.55,3.03l-1.35.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.13,85.22c-.07-.2-.56-1.09-1-1.83-.12-.1-.18-.08-.22-.07-.1.03-.2.11-.22.13l-1.07-1.05c.06-.06.59-.59,1.35-.59h0c.33,0,.82.1,1.3.59l.11.14c.32.54,1.08,1.84,1.2,2.27l-1.44.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.43,90.25c-.2-1.19-.52-1.54-.63-1.58-.09-.02-.33.11-.41.19l-1.05-1.07c.09-.09.92-.87,1.92-.55.84.27,1.38,1.17,1.65,2.75l-1.48.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.25,94.01h-1.5v-1.6c-.11,0-.28,0-.4.03l-.36-1.46c.18-.04,1.1-.24,1.73.23.33.24.52.61.54,1.05v1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.17,82.25l-1.4-.54c.42-1.08.28-1.38.28-1.38,0,.02-.14.04-.17.04l-.42-1.44c.11-.03,1.08-.29,1.7.4.8.87.2,2.41,0,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.61,86.99c-.14-1.56-.53-1.82-.55-1.83l-.75-1.32c.32-.18.89-.3,1.44,0,.76.4,1.21,1.39,1.35,3.03l-1.49.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.09,91.81c-1.04-1.9-1.57-1.99-1.58-1.99.07,0,.11-.06.12-.08l-1.3-.75c.18-.31.59-.67,1.18-.67h.02c.93.01,1.85.89,2.87,2.77l-1.32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.26,70.94l-.72-1.32c.71-.39,1.15-.91,1.33-1.6.38-1.43-.44-3.28-.84-3.99-3.68-3.29-10.41-15.83-10.7-16.37-3.21-4.81-5-4.8-5.01-4.8-3.26,1.13-5.71.54-5.81.52l.36-1.46s2.15.5,4.97-.48c.44-.14,2.78-.54,6.78,5.45.11.19,7.04,13.11,10.48,16.09l.15.17c.07.11,1.71,2.83,1.07,5.25-.29,1.09-.98,1.95-2.06,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.9,39.54l-1.45-.4c.02-.07,1.81-6.74-.72-14.1-.06-.21-4.32-16.13-6.33-19.23l1.26-.81c2.14,3.3,6.33,18.95,6.5,19.61,2.67,7.76.81,14.65.73,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.82,49.73l-1.43-.44c1.87-6.06-.6-11.75-.62-11.8-1.86-5.5-1.41-31.02-1.39-32.1l1.5.03c0,.26-.47,26.35,1.28,31.53.09.19,2.69,6.18.66,12.79Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTir);
export default __webpack_public_path__ + "static/media/tir.47437ca761bbdcd867facd7576dc0de3.svg";
export { ForwardRef as ReactComponent };